/**
 * 接口地址
 */
// const Url = "http://182.106.212.58";
const Url = 'http://zhsd.jxpskj.com' //测试环境域名
// const Url = 'http://192.168.0.109' //邓煜本地
// const Url = 'http://192.168.0.244' //邓帅本地
const weatherDomain = "https://free-api.heweather.com/s6/weather/";

const state = {
  // Url4: Url + ":9004/zhsd/", // 端口号
  // Url7: Url + ":9007/zhsd/",
  // Url8: Url + ":9008/zhsd/",
  // Url10: Url + ":9010/zhsd/",
    Url10: Url + '/zhsd-wetResource/', // 端口号2
    Url4: Url + '/zhsd-station/', // 端口号3
    Url8: Url + '/zhsd-patrol/', // 端口号4
    Url7: Url + '/zhsd-system/', // 端口号5
  TestUrl10: "http://192.168.0.183:9010/zhsd/",
  //天气预报api
  weather: {
    now: weatherDomain + "now", //实时天气
    airNow: "https://free-api.heweather.net/s6/air/now", //实时空气
    lifestyle: weatherDomain + "lifestyle", //生活指数
    forecast: weatherDomain + "forecast" //3-10天天气预报
  }
};

export default {
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/api.js